<template>
  <div id="contenedor-contrato-ubicacion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Contrato ubicación</v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la ubicación? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixBorrarContratoUbicacion"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoUbicaciones from './mixContratoUbicaciones';

export default {
  name: 'EliminarContratoUbicacion',
  mixins: [mixContratoUbicaciones],
  props: {
    ubicacionEditar: {
      type: Object,
      requirted: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  components: {
    CustomButton,
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
